import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import callApi from '../../utils/call_apis';
import sellerValidationSchema from '../../validations/SellerFormValidation';
import React from "react";
import Snackbar from '../generals/Snackbar';
import TextField from '@mui/material/TextField';
import { setSnackbar } from '../../stores/SnackbarSlice';
import { useFormik } from "formik";
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Link from '@mui/material/Link';
import Slider from "@madzadev/image-slider";
import "@madzadev/image-slider/dist/index.css";


function SellerResponseOnBidForm({ bidByEmpId }) {

  React.useEffect(() => {
    // AuthHelper.checkAuth()
    fetchMetadataOfBidByEmp({ id: bidByEmpId, form_action: form_action, product_details: 1 })
    if (form_action == 'update') {
      fetchBidDetailsBidBySeller({bid_by_emp: bidByEmpId})
    }
  }, []);

  const [searchParams, setSearchParams] = useSearchParams();
  let form_action = searchParams.get('form_action');
  // console.log('---form_action:', form_action);

  const navigate = useNavigate();
  const { auth_user } = useSelector((state) => state.authUser)
  // console.log('---SellerResponseOnBidForm--auth_user:', auth_user);

  const [initialValues, setInitialValues] = React.useState({
    'quantity': '',
    'bid_price': '',
    'comment': '',
    'price_with_gst': '',
    'price_without_gst': '',
    'discount_on_mrp': '',
    'discount_on_ptr': '',
    'bid_price_type_name': 'Price with GST',
    'product_expiry': '',
  });
  // console.log('---initialValues---111:', initialValues);
  const [bidMetaDetails, setBidMetaDetails] = React.useState({});
  console.log('----bidMetaDetails:', bidMetaDetails)
  const dispatch = useDispatch();



  const handleBidResponse = values => {
    values['bid_by_emp'] = bidByEmpId;
    sendBidResponse(values);
  }

  const formik = useFormik({
    initialValues,
    // onSubmit: (values, action) => console.log('okodkodw'),
    onSubmit: handleBidResponse,
    // validate,
    validationSchema: sellerValidationSchema.sellerResponseOnBidSchema,
    validateOnChange: false
  })

  // console.log('---formik--values:', formik.values);
  // console.log('---formik--errors:', formik.errors);

  const successResponse = (response) => {
    // console.log('---successResponse--response:', response);
    dispatch(setSnackbar({
      status: 'success',
      message: response.data.message
    }))
    navigate('/seller/bid-listing')
  }

  const errorResponse = (error) => {
    formik.setErrors({ ...error.response.data.errors })
    // console.log('---errorResponse--formik--errors---221:', formik.errors);
  }

  const sendBidResponse = async (data = {}) => {
    try {
      const response = await callApi.requestPOST(`/sellers-bids/seller/response-on-bid`, data, true)
      // console.log('---sendBidResponse---response:', response);
      successResponse(response)
    }
    catch (error) {
      // console.log('---sendBidResponse---error:', error);
      errorResponse(error)
    }
  }

  const fetchBidDetailsBidBySeller = async (data = {}) => {
    try {
      const response = await callApi.requestGET(`/sellers-bids/seller/bids-listing`, data, true)
      // console.log('---fetchBidDetailsBidBySeller---response:', response);
      // setInitialValues(() => response.data.data.dataset[0])
      formik.setValues(response.data.data.dataset[0])
    }
    catch (error) {
      // console.log('---fetchBidDetailsBidBySeller---error:', error);
      errorResponse(error)
    }
  }

  const fetchMetadataOfBidByEmp = async (data = {}) => {
    try {
      const response = await callApi.requestGET(`/sellers-bids/seller/bid-created-by-emp-listing`, data, true)
      // console.log('---fetchMetadataOfBidByEmp---response:', response);
      // console.log('---fetchMetadataOfBidByEmp---setBidMetaDetails---response:', response.data.data.dataset[0]);
      setBidMetaDetails(() => response.data.data.dataset[0])
      // setBidMetaDetails(response.data.data.dataset[0])
    }
    catch (error) {
      // console.log('---fetchMetadataOfBidByEmp---error:', error);
      errorResponse(error)
    }
  }


  return (
    <div>
      <div>

        {
          bidMetaDetails ?

            <Box component="form" className="" onSubmit={formik.handleSubmit}>
              <div className='tw-grid mob:tw-grid-cols-2 desktop:tw-grid-cols-2 tw-gap-5'>

                <div className='tw-col-span-2'>
                  {/* <TextField disabled id="productTitleId" className='tw-w-full' label="Product Name" variant="outlined" value={bidMetaDetails?.product_title || ''} onChange={() => ''} InputLabelProps={{ shrink: true }} /> */}
                  <span>&#8226; Product Name: {bidMetaDetails?.product_title}</span><br />
                  { bidMetaDetails?.product_details?.show_images?.length > 0 ? 
                  <span className='tw-flex tw-p-5'>
                    {/* <Slider imageList={images} width={300} height={300} showDotControls={false} /> */}
                    <Slider imageList={bidMetaDetails?.product_details?.show_images} width={300} height={300} showDotControls={false} />
                  </span>
                  : null
                  }
                  <span>&#8226; Bid Requested Qty: {bidMetaDetails?.quantity}</span><br />
                  <span>&#8226; Product expiry at least {bidMetaDetails?.product_expiry_type_name}</span><br />
                  <span>&#8226;&nbsp;
                    {/* {[3,4].includes(bidMetaDetails?.bid_price_type) ? 'Min' : 'Max'}&nbsp; */}
                    Requested Bid {bidMetaDetails?.bid_price_label}
                  </span><br />
                  {bidMetaDetails?.min_bid_by_other_seller ?
                    <p>&#8226; Lowest Bid till now submitted by another seller is <span className='tw-bg-amber-300'>{bidMetaDetails?.min_bid_by_other_seller}</span></p>
                    : null
                  }
                  {/* <span>&#8226; Requested Product Expiry: {bidMetaDetails?.product_expiry}</span><br/> */}
                  <span>&#8226; Bid Valid Till: {bidMetaDetails?.bid_valid_till}</span><br />
                </div>

                <div className='tw-col-span-1'>
                  <TextField id="quantityId" label="Quantity" type="number" name="quantity" variant="outlined" onChange={formik.handleChange} value={formik.values.quantity} error={formik.errors.quantity ? true : false} helperText={formik.errors.quantity} required />
                </div>

                <div className='tw-col-span-1'>
                  <TextField id="bidPriceId" label={`Bid ${bidMetaDetails?.bid_price_type_name || ''}`} type="number" name="bid_price" variant="outlined" onChange={formik.handleChange} value={formik.values.bid_price || initialValues.bid_price} error={formik.errors.bid_price ? true : false} helperText={formik.errors.bid_price} required />
                </div>

                <TextField id="commentId" className="tw-w-full" label="Comment" type="text" name="comment" variant="outlined" onChange={formik.handleChange} value={formik.values.comment} error={formik.errors.comment ? true : false} helperText={formik.errors.comment} required />

                {/* <div className='tw-col-span-1'>
              <TextField disabled={!bidMetaDetails?.price_with_gst} id="priceWithGstId" label="Price with GST" type="number" name="price_with_gst" variant="outlined" onChange={formik.handleChange} value={formik.values.price_with_gst || initialValues.price_with_gst} error={formik.errors.price_with_gst ? true : false} helperText={formik.errors.price_with_gst} />
            </div>

            <div className='tw-col-span-1'>
              <TextField disabled={!bidMetaDetails?.price_without_gst} id="priceWithoutGstId" label="Price without GST" type="number" name="price_without_gst" variant="outlined" onChange={formik.handleChange} value={formik.values.price_without_gst || initialValues.price_without_gst} error={formik.errors.price_without_gst ? true : false} helperText={formik.errors.price_without_gst} />
            </div>

            <div className='tw-col-span-1'>
              <TextField disabled={!bidMetaDetails?.discount_on_mrp} id="discountOnMrpId" label="Discount On MRP" type="number" name="discount_on_mrp" variant="outlined" onChange={formik.handleChange} value={formik.values.discount_on_mrp || initialValues.discount_on_mrp} error={formik.errors.discount_on_mrp ? true : false} helperText={formik.errors.discount_on_mrp} />
            </div>

            <div className='tw-col-span-1'>
              <TextField disabled={!bidMetaDetails?.discount_on_ptr} id="discontOnPtrId" label="Discount On PTR" type="number" name="discount_on_ptr" variant="outlined" onChange={formik.handleChange} value={formik.values.discount_on_ptr || initialValues.discount_on_ptr} error={formik.errors.discount_on_ptr ? true : false} helperText={formik.errors.discount_on_ptr} />
            </div> */}

                {/* <div className='tw-col-span-1'>
              <TextField id="productExpiryId" className="mob:tw-col-start-1 desktop:tw-col-start-2" label="Product Expiry" type="date" name="product_expiry" onChange={formik.handleChange} value={formik.values.product_expiry || initialValues.product_expiry} variant="outlined" InputLabelProps={{ shrink: true }} error={formik.errors.product_expiry ? true : false} helperText={formik.errors.product_expiry} required />
            </div> */}

                <div className='tw-col-span-1 mob:tw-col-start-1 desktop:tw-col-start-1'>
                  <Button type="submit" variant="contained">Submit Bid</Button>
                </div>

              </div>
            </Box>

            :
            <Box>
              <div>
                Bid is Expired! <br/>
                <p>Click <Link href="/seller/emp-bid-listing">here</Link> to know other Bids</p>
              </div>
            </Box>
        }

      </div>

      <Snackbar />
    </div>
  );

}


export { SellerResponseOnBidForm };
